"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const Store_1 = require("../Store");
let BrandBox = class BrandBox extends React.Component {
    onClick() {
        Store_1.default.SelectedBrand = this.props;
        Store_1.default.loadProducts();
        $([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, Store_1.default._scrollspeed);
    }
    render() {
        return (React.createElement(react_router_dom_1.Link, { to: this.props.url, onClick: this.onClick, className: "o-product-brand-wrapper col-md-4 col-sm-6 col-xs-6" },
            React.createElement("div", { style: { backgroundImage: "url(" + this.props.listingImageUrl + "?height=800&quality=70" + ")" }, className: "o-product-brand-container" },
                React.createElement("div", { className: "filter" }),
                React.createElement("h3", null, this.props.name))));
    }
};
__decorate([
    mobx_1.action.bound
], BrandBox.prototype, "onClick", null);
BrandBox = __decorate([
    mobx_react_1.observer
], BrandBox);
exports.default = BrandBox;
